import React from "react"

import { Palette, PaletteMode, styled } from "@mui/material"
import Button, { buttonClasses, ButtonProps } from "@mui/material/Button"

// eslint-disable-next-line unused-imports/no-unused-vars
export const RoundedActionButton = styled((props: RoundedActionButtonProps) => (
  <Button disableRipple disableFocusRipple disableTouchRipple disableElevation {...props} />
))(({ theme: { palette } }) => ({
  padding: ".8rem 1.6rem",
  borderRadius: "20rem",

  height: "4.4rem",

  textTransform: "none",
  fontSize: "1.4rem",
  fontWeight: 700,
  lineHeight: "2.8rem",

  "&::after": {
    content: "attr(aria-label)"
  },

  [`&.${buttonClasses.outlined}`]: {
    padding: ".7rem 1.6rem",

    [`&.${buttonClasses.colorInherit}`]: getInheritButtonColors({ mode: palette.mode }),
    [`&.${buttonClasses.colorSuccess}`]: getSuccessButtonColors({ palette }),
  },
}))

export type RoundedActionButtonProps = ButtonProps

// TODO: Get colors from theme palette
const getInheritButtonColors = ({ mode }: { mode: PaletteMode }) => ({
  color: mode === "dark" ? "#FFFFFF" : "#1A1A1A",
  background: mode === "dark" ? "#22202C" : "#FFFFFF",
  borderColor: mode === "dark" ? "#504B67" : "#79747E",

  "&:hover": {
    background: mode === "dark" ? "#2E2B3B" : "#F2F2F2",
  },
  "&:active": {
    background: mode === "dark" ? "#39364A" : "#E5E5E5",
  },
  "&:disabled": {
    color: mode === "dark" ? "#CCCCCC" : "#E5E5E5",
    background: mode === "dark" ? "#807A85" : "#CCCCCC",
  }
})

const getSuccessButtonColors = ({ palette }: { palette: Palette }) => ({
  background: palette.common.white,
  color: ButtonOutlinedDeliveryPlusText,
  border: `1px solid ${ButtonOutlinedDeliveryPlusText}`,

  "&:hover, &:active": {
    color: palette.common.white,
    border: `1px solid ${palette.common.black}`,
  },
  "&:hover": {
    background: "#008353",
  },
  "&:active": {
    background: "#007849",
  }
})

// TODO: Move to a theme palette
const ButtonOutlinedDeliveryPlusText = "#006132"
